<template>
  <SaugroboterFinderApp/>
</template>

<script>
import SaugroboterFinderApp from './components/SaugroboterFinderApp.vue';

export default {
  name: 'App',
  components: {
    SaugroboterFinderApp
  }
}
</script>

